module.exports = __webpack_public_path__ + "media/honey-icons/icon-connected-0eb80b16.svg";